var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"q-pa-md"},[_c('div',[_vm._v("Redirecting, please wait...")]),_c('q-btn',{attrs:{"color":"primary","label":"Click here if it takes too long","to":"/en-us"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }